import * as React from 'react';

import type { DocumentsFilterContextValue } from './DocumentsFilterContext.types';

import { DocumentsFilterContext } from './DocumentsFilterProvider';

export function useDocumentsFilter(): DocumentsFilterContextValue {
  const context = React.useContext(DocumentsFilterContext);

  if (!context) {
    throw new Error(
      'useDocumentsFilter must be used within DocumentsFilterProvider'
    );
  }

  return context;
}
